import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/color-list"
    path="business/color-list"
    element={<AsyncPage />}
  />,
];
